import React from 'react';
import KpiSummaryDashboard from '../personal-dashboard/kpi-summary/KpiSummaryDashboard';

const ManagerKpiSummaryDashboard = () => {
  return <KpiSummaryDashboard isFromManagerPage />;
};

ManagerKpiSummaryDashboard.propTypes = {};

export default ManagerKpiSummaryDashboard;
